<template>
    <section class="mb-[70px]">
        <SideBar ref="sidebar" @toggleBlur="handleBlurToggle" @mounted="handleSidebarMounted"/>
        <TopBar ref="topbar" @toggleBlur="handleBlurToggle"/>

        <div
            id="overlay"
            class="fixed inset-0 bg-black bg-opacity-30 z-30 transition-opacity duration-200"
            :class="{ 'hidden': !isBlur }"
            @click="closeSidebar"
        ></div>
    </section>
</template>

<script>
import TopBar from '@/components/TopBar.vue';
import SideBar from '@/components/SideBar.vue';

export default {
    name: 'IndexView',
    components: { TopBar, SideBar },
    data() {
        return {
            isBlur: false,
            sidebar: null
        }
    },
    methods: {
        handleBlurToggle(isBlurred) {
            this.isBlur = isBlurred;
        },
        closeSidebar() {
            if (this.$refs.sidebar) {
                this.$refs.sidebar.closeSidebar();
            }
        },
        handleSidebarMounted() {
            this.sidebar = this.$refs.sidebar;
        }
    },
    mounted() {
        this.handleSidebarMounted();
    }
}
</script>

<style>
#overlay {
    backdrop-filter: blur(5px);
}
html, body {
  overscroll-behavior: none;
}
</style>